import "./ExcelImportSummary.css";

export default function ExcelImportSummary({ result }) {
  const summary = result?.summary || {};

  const rowErrors = summary.row_errors || [];

  return (
    <section className="excel-import-summary">
      <div className="excel-import-summary__header">
        <h3>Import rapport</h3>
        <p>Import log: {result?.import_log_id || "-"}</p>
      </div>

      <div className="excel-import-summary__grid">
        <div>
          <span>Totaal rijen</span>
          <strong>{summary.total_rows || 0}</strong>
        </div>

        <div>
          <span>Geldige rijen</span>
          <strong>{summary.valid_rows || 0}</strong>
        </div>

        <div>
          <span>Ongeldige rijen</span>
          <strong>{summary.invalid_rows || 0}</strong>
        </div>

        <div>
          <span>Cliënten aangemaakt</span>
          <strong>{summary.clients_created || 0}</strong>
        </div>

        <div>
          <span>Cliënten hergebruikt</span>
          <strong>{summary.clients_reused || 0}</strong>
        </div>

        <div>
          <span>Dossiers aangemaakt</span>
          <strong>{summary.dossiers_created || 0}</strong>
        </div>

        <div>
          <span>Dossiers bijgewerkt</span>
          <strong>{summary.dossiers_updated || 0}</strong>
        </div>

        <div>
          <span>Velden aangemaakt</span>
          <strong>{summary.fields_created || 0}</strong>
        </div>

        <div>
          <span>Velden hergebruikt</span>
          <strong>{summary.fields_reused || 0}</strong>
        </div>
      </div>

      {rowErrors.length > 0 && (
        <div className="excel-import-summary__errors">
          <h4>Rijfouten</h4>

          <table>
            <thead>
              <tr>
                <th>Rij</th>
                <th>Fout</th>
              </tr>
            </thead>

            <tbody>
              {rowErrors.map((error, index) => (
                <tr key={`${error.row}-${index}`}>
                  <td>{error.row}</td>
                  <td>{error.message}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
